import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { useId } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
type Field = FieldRenderProps<string, HTMLInputElement> & {
  label: string;
};
export function RadioInput(props) {
  const $ = _c(17);
  const hasError = props.meta.error && props.meta.touched;
  const id = useId();
  let t0;
  if ($[0] !== props.className) {
    t0 = mergeClasses("ml-6 flex gap-1", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== id || $[3] !== props.input || $[4] !== props.label) {
    t1 = <input {...props.input} type="radio" placeholder={props.label} aria-label={props.label} id={id} data-clarity-mask="true" className="border-light-gray-500 relative float-left mt-0.5 mr-1 -ml-[1.5rem] h-5 min-h-5 w-5 min-w-5 appearance-none rounded-full border-2 border-solid before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:content-[''] after:absolute after:z-1 after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-blue-500 checked:before:opacity-[0.16] checked:after:absolute checked:after:top-1/2 checked:after:left-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:[transform:translate(-50%,-50%)] checked:after:rounded-full checked:after:border-blue-500 checked:after:bg-blue-500 checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] focus:ring-0 focus:outline-hidden focus:before:scale-100 focus:before:opacity-[0.12] checked:focus:border-blue-500 checked:focus:before:scale-100" />;
    $[2] = id;
    $[3] = props.input;
    $[4] = props.label;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== id || $[7] !== props.label) {
    t2 = <label className="cursor-pointer" htmlFor={id}>{props.label}</label>;
    $[6] = id;
    $[7] = props.label;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== hasError || $[10] !== props.meta.error) {
    t3 = hasError && <ErrorMessage error={props.meta.error} />;
    $[9] = hasError;
    $[10] = props.meta.error;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <div className={t0}>{t1}{t2}{t3}</div>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}